import React from "react";
import "./Icons.css";

const Icons = () => {
  return (
    <div className="features">
      <div className="row">
        <div className="feature-box col-lg-3">
          <i className="icon fas fa-suitcase fa-6x"></i>
          <h3>Larger luggage allowance</h3>
          <h5>
            Travel by ferry and take with you as much belongings as needed!
          </h5>
        </div>

        <div className="feature-box col-lg-3">
          <i className="icon fas fa-gem fa-6x"></i>
          <h3>Access hidden gems</h3>
          <h5>Reach destinations impossible to reach by the plane or car.</h5>
        </div>

        <div className="feature-box col-lg-3">
          <i className="icon fas fa-car fa-6x"></i>
          <h3>Bring your own car*</h3>
          <h5>
            We all like convenience and travelling by ferry you can take your
            car with you.{" "}
          </h5>
        </div>
        <div className="feature-box col-lg-3">
          <i className="icon fas fa-mountain fa-6x"></i>
          <h3>Beautiful views</h3>
          <h5>Breathtaking nature, beautiful lakes and mountains.</h5>
        </div>
      </div>
    </div>
  );
};

export default Icons;
